
export const methods = [
    {key:'Readings', text:'Readings'},
    {key:'RTYields', text:'RTYields'},
    {key:'SE', text:'SE'},
]